/* 24a: native touch/trackpad scrolling, keyboard controls and mouse dragging. */
if (!customElements.get('mc-review-strip')) {
  customElements.define('mc-review-strip', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      const signal = this.lifecycle.signal;
      this.track = this.querySelector('.mc-review-strip__track');
      this.cards = [...this.track.querySelectorAll('mc-review-quote')];
      this.dots = [...this.querySelectorAll('[data-review-dot]')];
      this.previous = this.closest('mc-product-reviews').querySelector('[data-review-previous]');
      this.next = this.closest('mc-product-reviews').querySelector('[data-review-next]');
      this.previous.addEventListener('click', () => this.go(this.index() - 1), { signal });
      this.next.addEventListener('click', () => this.go(this.index() + 1), { signal });
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), { signal }));
      this.track.addEventListener('scroll', () => this.update(), { passive:true, signal });
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.drag = { id:event.pointerId, x:event.clientX, left:this.track.scrollLeft, moved:false };
      }, { signal });
      this.track.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const distance = event.clientX - this.drag.x;
        if (!this.drag.moved && Math.abs(distance) < 6) return;
        this.drag.moved = true;
        this.track.setPointerCapture(event.pointerId);
        this.track.classList.add('is-dragging');
        event.preventDefault();
        this.track.scrollLeft = this.drag.left - distance;
      }, { signal });
      const stop = () => {
        if (!this.drag) return;
        const moved = this.drag.moved;
        this.drag = null;
        this.track.classList.remove('is-dragging');
        if (moved) { this.suppressClick = true; this.go(this.index()); setTimeout(() => this.suppressClick = false, 0); }
      };
      this.track.addEventListener('pointerup', stop, { signal });
      this.track.addEventListener('pointercancel', stop, { signal });
      this.track.addEventListener('lostpointercapture', stop, { signal });
      this.track.addEventListener('click', event => {
        if (this.suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, { capture:true, signal });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    position(index) { return this.cards[index].offsetLeft - this.cards[0].offsetLeft; }
    index() { return this.cards.reduce((best, card, index) => Math.abs(this.position(index) - this.track.scrollLeft) < Math.abs(this.position(best) - this.track.scrollLeft) ? index : best, 0); }
    go(index) { this.track.scrollTo({ left:this.position(Math.max(0, Math.min(index, this.cards.length - 1))), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); }
    update() {
      this.previous.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= this.position(this.cards.length - 1) - 1;
      const index = this.index();
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
    }
    disconnectedCallback() { this.lifecycle.abort(); this.resize.disconnect(); }
  });
}
